import { Component } from '@angular/core';

@Component({
    selector: 'ngx-card-layout',
    styleUrls: ['./card.layout.scss'],
    template: `
    <nb-layout center [withScroll]="true">
      <nb-layout-column class="account">
        <nb-card>
          <nb-card-body>
            <div class="account__body">
              <ng-content select="router-outlet"></ng-content>
            </div>
          </nb-card-body>
        </nb-card>
      </nb-layout-column>
    </nb-layout>
  `,
    standalone: false
})
export class CardLayoutComponent {}
